import { Button, Divider, Flex, Modal, Form } from "antd";
import { DocstoreSections } from "../../../../model";
import { useDocstoreSectionModal } from "./hooks";
import { docstoreUploadModalConfig } from "./model/config";
import { FieldConfig } from "./model/types";
import {
  ModalDatePicker,
  ModalDocumentUpload,
  ModalInput,
  ModalSelect,
  ModalWorkDraw,
} from "./ui";


interface IDocstoreSectionUploadModal {
  isModalOpen: boolean;
  handleOk: () => void;
  handleCancel: () => void;
}

export function DocstoreSectionUploadModal({
  isModalOpen,
  handleOk,
  handleCancel,
}: IDocstoreSectionUploadModal) {
  const { control, handleSubmit, reset, selectedSection } =
    useDocstoreSectionModal();

  const onSubmit = () => {
    handleOk();
    reset();
  };

  return (
    <Modal
      centered
      title="Загрузка документа"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={
        <Flex gap="small" justify="start">
          <Button
            type="primary"
            htmlType="submit"
            onClick={handleSubmit(onSubmit)}
          >
            Сохранить
          </Button>
          <Button onClick={handleCancel}>Отменить</Button>
        </Flex>
      }
    >
      <Form onFinish={handleSubmit(onSubmit)}>
        <Flex vertical gap="large">
          <ModalDocumentUpload control={control} />
          {DocstoreSections[selectedSection] in docstoreUploadModalConfig &&
            (
              docstoreUploadModalConfig[
                DocstoreSections[
                  selectedSection
                ] as keyof typeof docstoreUploadModalConfig
              ] as FieldConfig[]
            ).map((fieldConfig: FieldConfig) => (
              <>
                {fieldConfig.type === "input" && (
                  <ModalInput
                    fieldConfig={fieldConfig}
                    selectedSection={DocstoreSections[selectedSection]}
                    control={control}
                  />
                )}
                {fieldConfig.type === "select" && fieldConfig.options && (
                  <ModalSelect fieldConfig={fieldConfig} control={control} />
                )}
                {fieldConfig.type === "date" && (
                  <ModalDatePicker
                    selectedSection={DocstoreSections[selectedSection]}
                    fieldConfig={fieldConfig}
                    control={control}
                  />
                )}
              </>
            ))}
          {DocstoreSections[selectedSection] ===
            DocstoreSections.EXECUTIVE_SCHEME && <ModalWorkDraw />}
        </Flex>
      </Form>
      <Divider />
    </Modal>
  );
}

